import { useFormContext } from 'react-hook-form'

import type { InvoiceSettingsFormData } from '@/lib/schemas/invoice-settings-schemas'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Field } from '@/components/ui/field'
import { Input } from '@/components/ui/input'
import { m } from '@/lib/paraglide/messages'

export function InvoiceSettingsFields() {
    const form = useFormContext<InvoiceSettingsFormData>()
    return (
        <>
            <Card>
                <CardHeader>
                    <CardTitle>{m.invoice_company_info()}</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                    <Field
                        name="company_name"
                        label={m.invoice_company_name()}
                        required
                    >
                        <Input
                            id="company_name"
                            {...form.register('company_name')}
                        />
                    </Field>
                    <Field
                        name="company_address"
                        label={m.invoice_company_address()}
                        required
                    >
                        <Input
                            id="company_address"
                            {...form.register('company_address')}
                        />
                    </Field>
                    <div className="grid gap-4 sm:grid-cols-2">
                        <Field
                            name="company_phone"
                            label={m.invoice_company_phone()}
                            required
                        >
                            <Input
                                id="company_phone"
                                {...form.register('company_phone')}
                            />
                        </Field>
                        <Field
                            name="company_tax_code"
                            label={m.invoice_company_tax()}
                        >
                            <Input
                                id="company_tax_code"
                                {...form.register('company_tax_code')}
                            />
                        </Field>
                    </div>
                    <Field name="vat_percent" label="VAT (%)">
                        <Input
                            id="vat_percent"
                            inputMode="decimal"
                            className="w-32"
                            {...form.register('vat_percent')}
                        />
                    </Field>
                </CardContent>
            </Card>

            <Card>
                <CardHeader>
                    <CardTitle>{m.invoice_bank_info()}</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                    <Field name="bank_name" label={m.invoice_bank_name()}>
                        <Input id="bank_name" {...form.register('bank_name')} />
                    </Field>
                    <div className="grid gap-4 sm:grid-cols-2">
                        <Field
                            name="bank_account"
                            label={m.invoice_bank_account()}
                        >
                            <Input
                                id="bank_account"
                                {...form.register('bank_account')}
                            />
                        </Field>
                        <Field
                            name="bank_holder"
                            label={m.invoice_bank_holder()}
                        >
                            <Input
                                id="bank_holder"
                                {...form.register('bank_holder')}
                            />
                        </Field>
                    </div>
                </CardContent>
            </Card>

            <Card>
                <CardHeader>
                    <CardTitle>{m.invoice_footer()}</CardTitle>
                </CardHeader>
                <CardContent>
                    <Field
                        name="footer_note"
                        label={m.invoice_footer_note()}
                    >
                        <Input
                            id="footer_note"
                            placeholder={m.invoice_footer_placeholder()}
                            {...form.register('footer_note')}
                        />
                    </Field>
                </CardContent>
            </Card>
        </>
    )
}
